<template>
  <v-tabs v-model="helpIndex">
    <v-tab v-for="(item,index) in items" :key="index">{{item.title}}</v-tab>
    <v-tab-item v-for="(item,index) in items" :key="index" v-html="helpContent[index]">
    </v-tab-item>
  </v-tabs>
</template>
<script>
/* eslint-disable no-console */
import { getHtml } from '@/plugins/api';

export default {
  props: {
    toolId: { type: Number, required: true },
    items: { type: Array, required: true }
  },
  data () {
    return {
      helpIndex: 0,
      helpContent: []
    }
  },
  created () { this.init() },
  watch: {
    toolId () { this.init() },
    helpIndex (value) { this.loadHelpContent(value) }
  },
  methods: {
    loadHelpContent (index) {
      if (this.helpContent[index]) return;
      getHtml(this.items[index].fileUrl).then(res => this.$set(this.helpContent, index, res.data));
    },
    init () {
      this.helpIndex = 0;
      this.helpContent = [];
      this.loadHelpContent(this.helpIndex);
    }
  }
}
</script>